import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-errrors-popup',
  templateUrl: './errors4xx-popup.component.html',
  styleUrls: ['./errors4xx-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Err4XXPopupComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit(): void {}
}
